import { NotificationStyleInterface } from "./notification_container_interface";

export const notificationContainerDefaultStyle: NotificationStyleInterface = {
    textColor: "black",
    backgroundColor: "primary",
    borderColor: "white",
};
